import * as yup from 'yup';
import { getMaximumDeferralPeriod, getMinimumDeferralPeriod, validationValues } from '../config/formConfig';

export const rateInputSchema = yup.object({
  investorType: yup.string().test('not-empty', 'Please select investor type', value => ['new', 'existing'].includes(value as string)),
  investmentDate: yup.string().when('investorType', {
    is: 'existing',
    then: (schema) => schema
      .required('Investment date is required for existing investors')
      .test('is-past', 'Investment date must be in the past', (value) => {
        if (!value) return true;
        return new Date(value) < new Date();
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  lifeInsuredGender: yup.string().required('Please select gender'),
  lifeInsuredAge: yup.number().test(
    'in-range',
    '',
    function(value) {
      const { lifeInsuredAgeMin, lifeInsuredAgeMax } = validationValues
      if (!value || value > lifeInsuredAgeMax || value < lifeInsuredAgeMin) {
        return this.createError({
          message: `Set a value between ${lifeInsuredAgeMin} & ${lifeInsuredAgeMax}`
        });
      }
      return true;
    }
  ),
  hasSpouse: yup.mixed().test('not-empty', 'Please select an option', value => typeof value === "boolean"),
  spouseGender: yup.string().when('hasSpouse', {
    is: true,
    then: (schema) => schema.required('Please select a gender for Spouse'),
    otherwise: (schema) => schema.notRequired(),
  }),
  spouseAge: yup.number().when('hasSpouse', {
    is: true,
    then: (schema) => schema
      .transform((value) => value === '' ? undefined : Number(value))
      .min(validationValues.spouseAgeMin)
      .max(validationValues.spouseAgeMax)
      .required(),
    otherwise: (schema) => schema.notRequired(),
  }),
  youngerSpouse: yup.string().when(['hasSpouse', 'spouseAge', 'lifeInsuredAge'], {
    is: (hasSpouse: boolean, spouseAge: number, lifeInsuredAge: number) => 
      hasSpouse && Number(spouseAge) === Number(lifeInsuredAge),
    then: (schema) => schema
      .required('Please select who is younger'),
    otherwise: (schema) => schema.notRequired(),
  }),
  agePensionPlus: yup.mixed().test('not-empty', 'Please select an option', value => typeof value === "boolean"),
  paymentType: yup.string().test('not-empty', 'Please select payment type', value => ['fixed', 'rising'].includes(value as string)),
  deferralPeriod: yup.mixed().test(
    'in-range',
    '',
    function(value) {
      const minDeferral = getMinimumDeferralPeriod(this.parent.investmentDate, this.parent.investorType);
      const lifeInsuredAge = this.parent.lifeInsuredAge || 0;
      const maxDeferral = getMaximumDeferralPeriod(lifeInsuredAge);
      const message = `Set a value between ${minDeferral} & ${maxDeferral}`
      if (!value || value === undefined || Number.isNaN(value)) {
        return this.createError({message});
      }
      const numVal = Number(value)
      if (numVal > maxDeferral || numVal < minDeferral) {
        return this.createError({message});
      }
      return true;
    }
  )
});
